module.exports = __webpack_public_path__ + "static/media/wireshark.28ed024d.png";